// removed by extract-text-webpack-plugin
module.exports = {"subHeader":"_1Ejxe","arrowDown":"_2Kw19","articleContent":"_13Vk2"};


//////////////////
// WEBPACK FOOTER
// ./src/views/components/ArticlePageTemplate/ArticlePageTemplate.less
// module id = 917
// module chunks = 0